import * as THREE from "three";
import * as OC from "./OrbitControls";
import * as $ from "jquery";
import VoxelGrid from "./VoxelGrid";
const DEFAULTS = {
    size: 1,
    elevation: 0,
    speed: 1,
    axes: true,
    grid: true,
    ortho: true,
    sphere: false,
    voxel: false
};
export default class Program {
    constructor() {
        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.voxelGrid = new VoxelGrid();
        this.axesHelper = new THREE.AxesHelper(500);
        this.macroGrid = new THREE.GridHelper(99, 99 / 3);
        this.microGrid = new THREE.GridHelper(99, 99, 0x222222, 0x222222);
        this.sphereGeometry = new THREE.SphereGeometry(DEFAULTS.speed, 100, 100);
        this.sphereMaterial = new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.5, alphaTest: 0.5, visible: true, reflectivity: 0 });
        this.sphereMesh = new THREE.Mesh(this.sphereGeometry, this.sphereMaterial);
        this.orthoCamera = new THREE.OrthographicCamera(window.innerWidth / -2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / -2, -1000);
        this.perspCamera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 10000);
        this.directLight1 = new THREE.DirectionalLight(0xFFFFFF, 1);
        this.directLight2 = new THREE.DirectionalLight(0x4444FF, 1);
        this.ambientLight = new THREE.AmbientLight(0xFFFFFF, 0.25);
        this.useOrtho = DEFAULTS.ortho;
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        document.body.appendChild(this.renderer.domElement);
        this.microGrid.position.y -= 0.001;
        this.macroGrid.position.y -= 0.001;
        this.macroGrid.renderOrder = 1;
        this.orthoCamera.zoom = 50;
        this.orthoCamera.updateProjectionMatrix();
        const position = new THREE.Vector3(-5, 2.5, 10);
        position.normalize();
        position.multiplyScalar(10);
        this.orthoCamera.position.copy(position);
        this.perspCamera.position.copy(position);
        this.orthoControls = new OC.OrbitControls(this.orthoCamera, this.renderer.domElement);
        this.orthoControls.target.set(0, 0.5, 0);
        this.orthoControls.update();
        this.orthoControls.saveState();
        this.perspControls = new OC.OrbitControls(this.perspCamera, this.renderer.domElement);
        this.perspControls.target.set(0, 0.5, 0);
        this.perspControls.update();
        this.perspControls.saveState();
        this.directLight1.position.set(-99, 75, 99 >> 1);
        this.directLight1.target = this.microGrid;
        this.directLight2.position.set(99, -75, -99 >> 1);
        this.directLight2.target = this.microGrid;
        // @ts-ignore
        window.orthoCamera = this.orthoCamera;
        // @ts-ignore
        window.orthoControls = this.orthoControls;
        // @ts-ignore
        window.perspCamera = this.perspCamera;
        // @ts-ignore
        window.perspControls = this.perspControls;
        this.scene.add(this.macroGrid);
        this.scene.add(this.microGrid);
        this.scene.add(this.axesHelper);
        this.scene.add(this.voxelGrid);
        this.scene.add(this.sphereMesh);
        this.scene.add(this.directLight1);
        this.scene.add(this.directLight2);
        this.sphereMesh.position.set(0, 0.5, 0);
        this.sphereMesh.scale.setScalar((DEFAULTS.size / 2) + DEFAULTS.speed);
        this.sphereMesh.visible = DEFAULTS.sphere;
        // scene.add(ambientLight);
        this.voxelGrid.updateVolume(DEFAULTS.size, DEFAULTS.speed);
    }
    animate() {
        requestAnimationFrame(this.animate.bind(this));
        if (this.useOrtho) {
            if (!this.perspCamera.position.equals(this.orthoCamera.position)) {
                this.perspCamera.position.copy(this.orthoCamera.position);
                this.perspControls.update();
            }
            this.renderer.render(this.scene, this.orthoCamera);
        }
        else {
            if (!this.orthoCamera.position.equals(this.perspCamera.position)) {
                this.orthoCamera.position.copy(this.perspCamera.position);
                this.orthoControls.update();
            }
            this.orthoCamera.position.copy(this.perspCamera.position);
            this.renderer.render(this.scene, this.perspCamera);
        }
    }
    update() {
        const size = parseInt($('#size').val());
        const speed = parseInt($('#speed').val()) / 5;
        this.sphereMesh.scale.setScalar((size / 2) + speed);
        this.sphereMesh.position.setY(this.voxelGrid.position.y + 0.5);
        this.voxelGrid.updateVolume(size, speed);
    }
    init() {
        $('#size').val(DEFAULTS.size);
        $('#elevation').val(DEFAULTS.elevation * 5);
        $('#speed').val(DEFAULTS.speed * 5);
        $('#axes').prop('checked', DEFAULTS.axes);
        $('#grid').prop('checked', DEFAULTS.grid);
        $('#ortho').prop('checked', DEFAULTS.ortho);
        $('#sphere').prop('checked', DEFAULTS.sphere);
        $('#voxel').prop('checked', DEFAULTS.voxel);
        this.update();
        $('#cam-reset').on('click', () => {
            this.orthoControls.reset();
            this.perspControls.reset();
        });
        $('#recalc').on('click', () => {
            this.voxelGrid.fillSize();
            this.voxelGrid.fillSphere();
        });
        document.getElementById('elevation').addEventListener("change", (event) => {
            this.voxelGrid.position.y = parseInt(event.currentTarget.value) / 5;
            this.update();
        });
        document.getElementById('speed').addEventListener("change", () => this.update());
        document.getElementById('size').addEventListener("change", () => this.update());
        document.getElementById('axes').addEventListener("change", (event) => {
            this.axesHelper.visible = event.currentTarget.checked;
        });
        document.getElementById('grid').addEventListener("change", (event) => {
            this.microGrid.visible = event.currentTarget.checked;
            this.macroGrid.visible = event.currentTarget.checked;
        });
        document.getElementById('ortho').addEventListener("change", (event) => {
            this.useOrtho = event.currentTarget.checked;
        });
        document.getElementById('sphere').addEventListener('change', (event) => {
            var checked = event.currentTarget.checked;
            this.sphereMesh.visible = checked;
        });
        document.getElementById('voxel').addEventListener("change", (event) => {
            var checked = event.currentTarget.checked;
            if (checked == this.voxelGrid.wholeSphere)
                return;
            if (checked) {
                if (confirm("Are you sure you want to show the whole sphere? This can be very slow if used with large spheres.")) {
                    this.voxelGrid.wholeSphere = true;
                    this.update();
                }
            }
            else {
                this.voxelGrid.wholeSphere = false;
                this.update();
            }
        });
        document.body.onkeyup = event => {
            this.orthoControls.reset();
            this.perspControls.reset();
            switch (event.code) {
                case "KeyT":
                    $('#ortho').prop('checked', DEFAULTS.ortho);
                    this.useOrtho = true;
                    this.orthoCamera.position.set(0, 10.5, 0);
                    break;
                case "KeyF":
                    $('#ortho').prop('checked', DEFAULTS.ortho);
                    this.useOrtho = true;
                    this.orthoCamera.position.set(0, 0.5, 10);
                    break;
            }
            this.orthoControls.update();
        };
    }
}
window.onload = () => {
    console.log('Creating Program');
    const program = new Program();
    console.log('Initializing Program');
    program.init();
    console.log('Starting Program');
    program.animate();
};
